import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { EditorView, basicSetup } from "codemirror";
import { unifiedMergeView } from "@codemirror/merge";
import { json } from "@codemirror/lang-json";
import { Box } from "@mantine/core";
export const CodeDiff = ({ value = "", original = "", }) => {
    const editorRef = useRef(null);
    const containerRef = useRef(null);
    const currentValue = useRef(value);
    currentValue.current = value;
    /**
     * Initialize editor on mount
     */
    useEffect(() => {
        if (!containerRef.current)
            return;
        if (editorRef.current)
            return;
        const diff = unifiedMergeView({
            original: original,
            mergeControls: false,
            collapseUnchanged: {
                margin: 10,
                minSize: 10,
            },
        });
        editorRef.current = new EditorView({
            doc: value,
            parent: containerRef.current,
            extensions: [basicSetup, json(), diff],
        });
    }, [value, original]);
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: `
        .cm-editor { 
          height: 100%;
          width: 100%;
        }
      ` }), _jsx(Box, { w: "100%", h: "100%", ref: containerRef })] }));
};
